import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PopupService } from './services/popup.service';
import { PopupLoader } from './services/popup-loader';

/** @deprecated - inline implementation in your local component. This entire module will be removed */
@NgModule({
  imports: [CommonModule],
})
export class PopupModule {
  static forRoot(): ModuleWithProviders<PopupModule> {
    return {
      ngModule: PopupModule,
      providers: [PopupService, PopupLoader],
    };
  }
}
